'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { captureSentryErrorBoundaryException } from '@workspace/analytics/sentry/client';
import { GeneralErrorPage } from '@workspace/ui';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

interface ErrorProps {
  error: Error & { digest?: string };
}

export default function Error({ error }: ErrorProps) {
  const router = useRouter();

  useEffect(() => {
    captureSentryErrorBoundaryException(error);
  }, [error]);

  return (
    <GeneralErrorPage
      error={error}
      fillViewport
      showStackTrace={process.env.ENVIRONMENT_NAME !== 'prod'}
      onTryAgain={() => window.location.reload()}
      onGoBack={() => router.push('/')}
    />
  );
}
